import { Companion_getInstance16dzvgcii8pc4 as Companion_getInstance } from '../../../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  writer1eia5its2a1fh as writer,
  writeFully1yd4favg5iwxl as writeFully,
  WriterScope3b0bo1enaee6b as WriterScope,
} from '../../../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import { SafeContinuation1x0fxyaxo6cwq as SafeContinuation } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/SafeContinuationJs.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { asByteArray281a45t1cr5zc as asByteArray } from '../ReadableStream.mjs';
import { awaitd1m8y0em728c as await_0 } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Promise.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readBodyBrowser(_this__u8e3s4, response) {
  var tmp0_elvis_lhs = response.body;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Companion_getInstance().z4o_1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stream = tmp;
  return channelFromStream(_this__u8e3s4, stream);
}
function channelFromStream(_this__u8e3s4, stream) {
  return writer(_this__u8e3s4, VOID, VOID, channelFromStream$slambda_0(stream)).v4o_1;
}
function *readChunk(_this__u8e3s4, $completion) {
  // Inline function 'kotlin.coroutines.suspendCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var c = $completion;
    var safe = SafeContinuation().hd(intercepted(c));
    var continuation = safe;
    var tmp = _this__u8e3s4.read();
    var tmp_0 = tmp.then((it) => {
      var chunk = it.value;
      var result = it.done ? null : chunk;
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$5 = _Result___init__impl__xyqfz8(result);
      this_0.rc(tmp$ret$5);
      return Unit_instance;
    });
    tmp_0.catch((cause) => {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = continuation;
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(cause));
      this_0.rc(tmp$ret$7);
      return Unit_instance;
    });
    return safe.id();
  };
}
function channelFromStream$slambda$lambda(it) {
  return Unit_instance;
}
var channelFromStream$slambdaClass;
function channelFromStream$slambda() {
  if (channelFromStream$slambdaClass === VOID) {
    class $ {
      constructor($stream) {
        this.y65_1 = $stream;
      }
      *l5e($this$writer, $completion) {
        var reader = this.y65_1.getReader();
        try {
          $l$loop: while (true) {
            var tmp0_elvis_lhs = yield* /*#__NOINLINE__*/readChunk(reader, $completion);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              break $l$loop;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var chunk = tmp;
            yield* writeFully($this$writer.f4p_1, asByteArray(chunk), VOID, VOID, $completion);
            yield* $this$writer.f4p_1.g4o($completion);
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var cause = $p;
            var tmp_0 = reader.cancel(cause);
            yield* await_0(tmp_0.catch(channelFromStream$slambda$lambda), $completion);
            throw cause;
          } else {
            throw $p;
          }
        }
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.l5e(p1 instanceof WriterScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    channelFromStream$slambdaClass = $;
  }
  return channelFromStream$slambdaClass;
}
function channelFromStream$slambda_0($stream) {
  var i = new (channelFromStream$slambda())($stream);
  var l = ($this$writer, $completion) => i.l5e($this$writer, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  readBodyBrowser as readBodyBrowser2vmfk0na3k29n,
};
//endregion

//# sourceMappingURL=BrowserFetch.mjs.map
